/**
 * @file workspace-area.ts
 * @description Где стоит рабочая область конструктора (навигатор · канва ·
 * панель) на планшете и ПК (phase19.16; замечание владельца 2026-10-18 со
 * вторым снимком: область кончалась ~180 px выше низа окна — высота через
 * `100dvh` у него не равнялась окну).
 *
 * С 1024 (верхняя полоса конструктора уходит в шапку кабинета) область
 * закреплена `fixed` от низа шапки (`--shell-sticky-top`) до низа окна, слева
 * от края постоянного меню (`--app-bar-left`; меню в шторке — 0), справа до
 * края окна; высота не считается вовсе. Слой `z-[1]` — ниже шапки (30),
 * нижней полосы (30), чата (45), шторки и окон (порталы 50+). На 768–1023
 * верхняя полоса и нижняя полоса каркаса в потоке — прежняя формула высоты.
 * Прокрутка всей страницы запрещена ровно там, где область закреплена
 * (`pageScrollLocked`, тот же порог 1024 = `lg:` = `LG_QUERY`): на 768–1023
 * панель с «Сохранить блок» иначе ушла бы под нижнюю полосу без прокрутки
 * (ревью Н1).
 */

/** Раскладка рабочей области (на телефоне — свой экран `BuilderPhone`). */
export type WorkspaceLayout = "desktop" | "tablet";

/** Закрепление от шапки до низа окна. */
const FIXED = "fixed right-0 bottom-0 top-[var(--shell-sticky-top)] left-[var(--app-bar-left,0px)] z-[1]";
/** То же с 1024 (`lg:`) — у планшета. Классы буквально: Tailwind ищет их в тексте файла. */
const FIXED_LG = "lg:fixed lg:right-0 lg:bottom-0 lg:top-[var(--shell-sticky-top)] lg:left-[var(--app-bar-left,0px)] lg:z-[1] lg:h-auto";
/** До 1024: всё под шапкой минус строка статуса и нижняя полоса каркаса. */
const FLOW_HEIGHT = "h-[calc(100dvh-var(--shell-sticky-top)-9rem)]";

/** Классы положения и высоты области по раскладке. */
export function workspaceAreaClass(layout: WorkspaceLayout): string {
  // ПК — всегда от 1280, то есть выше порога 1024.
  return layout === "desktop" ? FIXED : `${FLOW_HEIGHT} ${FIXED_LG}`;
}

/** Раскладка конструктора целиком (на телефоне — свой экран). */
export type BuilderLayoutKind = WorkspaceLayout | "phone";

/**
 * Запрещать ли прокрутку страницы: ПК — всегда (от 1280), планшет — только
 * с 1024 (`lg` — то же, что `lg:fixed` выше), телефон — никогда.
 */
export function pageScrollLocked(layout: BuilderLayoutKind, lg: boolean): boolean {
  return layout === "desktop" || (layout === "tablet" && lg);
}
